import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/app/providers/AuthProvider";
import { ProblemSolveNotifier } from "@/features/problem-solve/components/ProblemSolveNotifier";
import { LoadingSpinner } from "@/shared/components/LoadingSpinner";
import { getProblemSolveCapabilities } from "@/shared/utils/roles";

export function ProblemSolveSectionOutlet() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!getProblemSolveCapabilities(user?.role).canAccess) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <ProblemSolveNotifier />
      <Outlet />
    </>
  );
}
